const NewPodcastsSlider = (target) => {
  const initSlider = ($el, params) => {
    $el.slick(params);
  };
  $('body').find(target)
    .each((_, el) => {
      const $el = $(el);
      const params = {
        slidesToShow: 2,
        arrows: false,
        dots: true,
        infinite: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      }
      initSlider($el, params);

      $(window).on('resize', () => {
        if (!$el.hasClass('slick-initialized')) {
          initSlider($el, params)
        }
      });
    });
}

export default NewPodcastsSlider;



// WEBPACK FOOTER //
// ./scripts/components/NewPodcastsSlider.js